import { Col, Row, Typography } from "antd"
import { PhoneOutlined, UserOutlined } from "@ant-design/icons";

const MotoristaDetalhePedido = ({ order = {} }) => {
  return (
    <div>
      <Typography.Title level={2}>Motorista</Typography.Title>
      <Row type={"flex"} gutter={14}>
        <Col>
          <UserOutlined />
        </Col>
        <Col>
          <Typography.Text>{order.driverName}</Typography.Text>
        </Col>
      </Row>

      <Row type={"flex"} gutter={14}>
        <Col>
          <PhoneOutlined/>
        </Col>
        <Col>
          <Typography.Text>{order.driverPhone}</Typography.Text>
        </Col>
      </Row>
    </div>
  )
}

export default MotoristaDetalhePedido;
